import clsx from "clsx";


const StepTitle = ({ n, title, active }) => (
  <div className="p-4 pl-0">
    <span className={clsx({
      "p-1.5 px-3 shadow-sm rounded-full":true,
      "bg-red-600 text-white" : active,
      "bg-gray-200" : !active,
    })}>
      {n}
    </span>
    <span className="pl-4 font-bold"> {title} </span>
  </div>
);

export default StepTitle;
